import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import Snackbar from "../../../../../Snackbar";
import QueOptionsForResponse from "./QueOptionsForResponse";

  
const QuestionOptionsStatic= ({answerResponse,themeColor,questionObject,questionType})=>{ 
  
   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
    const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
           
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
  
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      ;
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    const appId = useSelector((state)=>state?.app?.app?.ID);
    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
    
     const [loader , setLoader] =useState({status:false});
     const [animate, setAnimate] = useState(false);
    
         const [deleteSectionPopUp, setDeleteSectionPopUp] = useState(false);
         const [deleteId, setDeleteId] = useState("");
            const [isLockSections, setIsLockSections] = useState();
      const [createNewOptionPopUp, setCreateNewOptionPopUp] = useState(false);
    // let allSections= allSectionsData
const [parentFolder, setParentFolder] = useState({ID:""});
    
        const [allSections, setAllSections] = useState([]);
        const [currentOption, setCurrentOption] = useState({});
        
       
        const [ visibility, setVisibility] = useState("public");
        const [ objectNew, isObjectNew] = useState(false);
          
 const [itemArr, setItemArr] = useState([]);
  
     useEffect(() => {
        setItemArr( questionObject?.options?.length?questionObject?.options:questionType=="NAT"||questionType=="Drag Matching"?questionObject?.options:questionType=="True-False"?questionObject?.options:[])

       
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
    
      useEffect(()=>{
        
      },[])
   


    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';

const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

 

     
   
     return(<>
              {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )} 
    <div > 
        
    <div  className=""style={{margin:"10px"}}>
   
               <div  className=" " style={{borderRadius:"25px",}}>
  <div  className=" " >
    
  
<div  className=""style={{ 
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 2s ease, opacity 1s ease', 
   }}>
{flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.ID} 
          >
        
            <div
           
            ><QueOptionsForResponse answerResponse={(status)=>{answerResponse(status)}} themeColor={themeColor} questionType={questionType} element={item}  index={index} key={item.ID} 
               isLockSections={isLockSections} lockTimeSent={item.lockTime}
            
         optionText={item.optionText}  id={item.ID}  
           />
                </div>
          
          </div>)):'' }
  
   
    </div>  
     {flattenedDataLoading.length==0&&flattenedData.length==0&&questionType!=="Essay"? <div style={{fontSize:"28px",fontWeight:"bold",padding:"5px",marginTop:"45px",
                 paddingLeft:"10px",display:"flex",margin:"15px",justifyContent:"center",border:"3px solid rgba(144, 202, 249,0.41)",marginTop:"10px",background:"#ffffff",borderRadius:"15px",padding:"5px",
             display:"flex",justifyContent:"center"
            }}>
             No Option Found </div>:"" }
    
     <div align="center">


    </div>
    </div>   <div  className=""style={{
        transform: animate ? 'scale(1)' : 'scale(.9)',marginTop:"50px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
         

        </div>  </div>  </div>  </div> 

  
      
                                    
     </>)  
   }
   export default QuestionOptionsStatic;